import { render, staticRenderFns } from "./UserSearchAndSelect.vue?vue&type=template&id=5e8f70b2&scoped=true&"
import script from "./UserSearchAndSelect.vue?vue&type=script&lang=ts&"
export * from "./UserSearchAndSelect.vue?vue&type=script&lang=ts&"
import style0 from "./UserSearchAndSelect.vue?vue&type=style&index=0&id=5e8f70b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f70b2",
  null
  
)

export default component.exports